export default "__VITE_ASSET__Dbtm7DMe__"